import { NavLink, Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../features/auth/context'
import { LanguageSwitcher } from './LanguageSwitcher'

export function AppLayout() {
  const { t } = useTranslation()
  const { user, logout } = useAuth()

  return (
    <div className="app">
      <header className="app__header">
        <div className="brand">
          <span className="brand__mark" aria-hidden="true">
            TC
          </span>
          <span>
            <strong className="brand__name">{t('app.name')}</strong>
            <span className="brand__tagline">{t('app.tagline')}</span>
          </span>
        </div>

        <nav className="nav" aria-label={t('nav.primary')}>
          <NavLink to="/dashboard" className="nav__link">
            {t('nav.dashboard')}
          </NavLink>
          <NavLink to="/alerts" className="nav__link">
            {t('nav.alerts')}
          </NavLink>
          <NavLink to="/brokers" className="nav__link">
            {t('nav.brokers')}
          </NavLink>
          <NavLink to="/carriers" className="nav__link">
            {t('nav.carriers')}
          </NavLink>
          <NavLink to="/availability" className="nav__link">
            {t('nav.availability')}
          </NavLink>
          <NavLink to="/loads" className="nav__link">
            {t('nav.loads')}
          </NavLink>
          <NavLink to="/rate-confirmations" className="nav__link">
            {t('nav.rateConfirmations')}
          </NavLink>
          {/* No commission calculator (TRKC-97): it was Stage 0's proof that the portal,
              the API and the roles worked together, and it read as a feature. Its page
              stays at /commissions for that proof; real commissions arrive with Stage 5. */}
        </nav>

        <div className="session">
          <LanguageSwitcher />
          <span className="session__user">{user?.email}</span>
          <button type="button" className="session__logout" onClick={() => void logout()}>
            {t('auth.signOut')}
          </button>
        </div>
      </header>

      <main className="app__main">
        <Outlet />
      </main>
    </div>
  )
}
